import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import MainWindow from '../../Wrappers/MainWindow';
import icon from '../../../svg/submitted-offer.svg';
import Frame from '../../Wrappers/Frame';
import '../Offer.css';

const Title = styled.div`
  text-align: center;
  padding-top: 10px;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 1px;
  color: var(--color-beige);
`;

const Subtitle = styled.div`
  margin: auto;
  width: 70%;
  margin-top: 20px;
  font-size: 16px;
  letter-spacing: 0.7px;
  color: #ffffff;
`;

const Icon = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
`;

const Container = styled.div`
  width: 400px;
  color: #ffffff;
  height: 400px;
  background-color: var(--color-gunmetal);
  font-family: BrandonGrotesque-Regular;
  margin: auto;
`;

const Button = styled.div`
  width: 100px;
  margin: auto;
  margin-top: 20px;
  cursor: pointer;
  height: 40px;
  border-radius: 2px;
  background-color: var(--color-gunmetal);
  font-family: BrandonGrotesque-Regular;
  font-size: 22px;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 1.1px;
  text-align: center;
  color: #ffffff;
`;

function OfferSubmitted(props: { redirect: Function }) {
  return (
    <MainWindow page="createOffer">
      <Frame title="Offer Submitted" fullHeight={true}>
        <Container>
          <Icon src={icon} alt="Submitted!" />
          <Title>Your offer has been submitted!</Title>
          <Subtitle>
            A Neon Coat representative will be in touch to further customize your offer or let you
            know that it's been approved.
          </Subtitle>
        </Container>
        <Button onClick={() => props.redirect()}>OKAY</Button>
      </Frame>
    </MainWindow>
  );
}

export default connect(null, { redirect: () => push('/offers/upcoming') })(OfferSubmitted);
